var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFallingFrameRight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 991 958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbbcaa;}.cls-2{fill:#173856;}.cls-3{fill:#20456e;}.cls-4{fill:#639;}.cls-5{fill:#efa44b;}.cls-6{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chute") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chute"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bras_arri\\xE8re",
    "data-name": "bras arri\\xE8re"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M927.52,1260.84S907,1333.13,950.79,1330s33.31-70,33.31-70Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M934.11,1070.92s38.73-75.85,87.9-14.11L997.15,1268s-44.71,14.52-78-4C923.23,1188.83,934.11,1070.92,934.11,1070.92Z",
    transform: "translate(-508 -621)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1033.42,1266.26l-100.1-176.6s-24.65-43.5,32.77-76.05,77.14,2.26,77.14,2.26l105,185.31Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1355.32,1178.93s-171.71-14.22-229.64,26c26.69,32.41,3.75,102.38,26.73,105.08,34,4,92.11-12.07,92.11-12.07s80.24-20.45,121.32-10.38c0,0,6.67,7.84,16.15,8.19s57.47-5.14,57.47-5.14l-15.07-173.34S1341.29,1113.86,1355.32,1178.93Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1077.76,1312.74s86.1,56.56,124.83,147.1c-7.46,11.85,38.25,72.52,38.25,72.52l141.49-95.28s-27.91-58.92-82.06-29.19c-23-49.9-98.69-172.8-152.86-206.89-26,15-90,44-114,59C1027.41,1275,1077.76,1312.74,1077.76,1312.74Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M822,1147.91s-67.61,32.76-36.17,63.35,74.41-21.64,74.41-21.64Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M968.28,1026.58s82.41-21.49,69,56.27L863,1204.67s-40.57-23.75-48.89-60.91C873,1096.84,968.28,1026.58,968.28,1026.58Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M939.34,1034.58c5.8-7.2,14.17-14.41,26.07-21.15,57.42-32.55,78.88,1.27,78.88,1.27S1018.91,1000.34,939.34,1034.58Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1022.18,
    y: 1226.05,
    width: 132,
    height: 8,
    transform: "translate(-973.03 75.48) rotate(-29.54)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 498,
    cy: 209,
    r: 169
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M967.21,915l-10,77.13S800.21,965,823.21,788c13.94-107.25,110.8-146.53,194-140,26.28,2.06,70.79,18.2,101,41a195.79,195.79,0,0,1,49,55l-103,42-58,81s-27.67-26.15-54-14C926.21,865,932.21,919,967.21,915Z",
    transform: "translate(-508 -621)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_9",
    "data-name": "Calque 9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 991,
    height: 958
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallingFrameRight1);
export default __webpack_public_path__ + "static/media/falling_frame_right_1.4513bef6d09e6976c1b27677cfc0dbf6.svg";
export { ForwardRef as ReactComponent };